
import React from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import IVHero from './components/IVHero';
import TreatmentOptions from './components/TreatmentOptions';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const IVVitaminTherapy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <IVHero />
        <TreatmentOptions />
        <BenefitsSection />
        <ProcessSection />
        <PricingSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default IVVitaminTherapy;
